import React from "react"
import { PAGINATION_VALUE_PRESETS } from "../utils/design-helpers"

export const usePagination = (
  itemsPerPageValues = PAGINATION_VALUE_PRESETS,
  currentPageIndex: number,
  navigate: (pageIndex: number) => void,
) => {
  const [itemsPerPage, setItemsPerPage] = React.useState(itemsPerPageValues[0])
  const [offset, setoffset] = React.useState<number>(currentPageIndex > 1 ? (currentPageIndex - 1) * itemsPerPage : 0)

  const totalPages = (totalCount: number) => (totalCount < itemsPerPage ? 1 : Math.ceil(totalCount / itemsPerPage))

  const onClickPage = (newPage: number) => {
    if (newPage !== currentPageIndex) {
      setoffset(offset ? itemsPerPage * (newPage - 1) : itemsPerPage)
      navigate(newPage)
    }
  }

  const onItemsPerPageChange = (n: number) => {
    setItemsPerPage(n)
  }

  return {
    first: itemsPerPage,
    skip: offset,
    onClickPage,
    getPaginationProps: (totalCount: number) => ({
      currentPageIndex,
      onClickPage,
      onItemsPerPageChange,
      itemsPerPage,
      itemsPerPageValues,
      pages: totalPages(totalCount),
    }),
  } as const
}
